import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminCustomers() {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/admin/customers").then((r) => setUsers(r.data)); }, []);
  return (
    <div>
      <div className="kyro-overline">People</div>
      <h1 className="font-display font-black text-3xl md:text-4xl tracking-tighter mt-2 mb-8">Customers</h1>
      <div className="kyro-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-white/5">
            <tr className="text-left">
              <th className="px-4 py-3 font-medium text-kyro-mute">Name</th>
              <th className="px-4 py-3 font-medium text-kyro-mute">Email</th>
              <th className="px-4 py-3 font-medium text-kyro-mute">Provider</th>
              <th className="px-4 py-3 font-medium text-kyro-mute">Role</th>
              <th className="px-4 py-3 font-medium text-kyro-mute">Joined</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t border-white/5" data-testid={`admin-customer-${u.email}`}>
                <td className="px-4 py-3">{u.name || "—"}</td>
                <td className="px-4 py-3 text-kyro-mute">{u.email}</td>
                <td className="px-4 py-3 text-xs uppercase">{u.auth_provider}</td>
                <td className="px-4 py-3 text-xs uppercase">{u.role}</td>
                <td className="px-4 py-3 text-xs text-kyro-mute">{u.created_at ? new Date(u.created_at).toLocaleDateString() : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
